(function () {
    'use strict';

    /*
     UserRegisterController
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.register', [])

        /**
          * UserRegisterController - handle register form & send request to server
          * to submit form data. 
          *
          * @inject __Form
          * @inject $state
          * @inject appServices
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserRegisterController', [
            '__Form',
            '$state',
            'appServices',
            '__Utils',
            function (__Form, $state, appServices, __Utils) {

                var scope = this;
                scope.show_captcha = false;

                scope = __Form.setup(scope, 'user_register_form', 'userData', {
                    secured: true
                });

                /**
                  * Get login attempts for this client ip
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                __Form.fetch('user.register.supportData').success(function (responseData) {
                    scope.show_captcha = true;
                    scope.site_key = responseData.data.site_key;
                });


				/**
				  * Fetch captch url
				  *
				  * @return string
				  *---------------------------------------------------------------- */

                scope.getCaptchaURL = function () {
                    return __Utils.apiURL('security.captcha') + '?ver=' + Math.random();
                };

                /**
                  * Refresh captch 
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.refreshCaptcha = function () {
                    scope.captchaURL = scope.getCaptchaURL();
                };

                scope.captchaURL = scope.getCaptchaURL();
                scope.errorMessage = false;
                /**
                  * Submit register form action
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submit = function () {

                    scope.isInActive = false;

                    __Form.process('user.register.process', scope)
                        .success(function (responseData) {

                            var requestData = responseData.data;

                            appServices.processResponse(responseData, {
                                error: function () {

                                },
                                otherError: function () {

                                    if (responseData.reaction == 3 && !_.isEmpty(responseData.message)) {
                                        scope.errorMessage = responseData.message;
                                    }

                                    //console.log(responseData.message);
                                    scope.isInActive = requestData.isInActive;

                                    // reset password field
                                    scope[scope.ngFormModelName].password = "";
                                    scope[scope.ngFormModelName].password_confirmation = "";

                                    // refresh captcha
                                    scope[scope.ngFormModelName].confirmation_code = "";
                                    scope.refreshCaptcha();

                                }
                            },
                                function () {
                                    __globals.redirectBrowser(__Utils.apiURL('user.register.success'));
                                });

                        });

                };

                /**
                  * Show terms and conditions dialog
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.showTermsAndConditionsDialog = function () {

                    appServices.showDialog(scope,
                        {
                            templateUrl: __globals.getTemplateURL(
                                'user.terms-and-conditions'
                            )
                        },
                        function (promiseObj) {
                        });

                };

            }
        ]);

})();